var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormRequestError } from './index';
import { mutationTypes } from './mutations';
import { container } from 'tsyringe';
import { FormRepository } from 'packages/form/FormRepository';
import { FormTypes } from 'packages/form/entities/legacy/Form';
import { EntityBuilder } from '@decahedron/entity';
import { Pagination } from 'packages/core/Pagination';
var searchFormsQuery = '';
export var actions = {
    searchForms: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var repo, r, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        repo = container.resolve(FormRepository);
                        searchFormsQuery = payload.query;
                        commit(mutationTypes.SET_LOADING_FORMS, true);
                        commit(mutationTypes.SET_ERROR, FormRequestError.NO_ERROR);
                        commit(mutationTypes.SET_FILTERED_FORM_COUNT, 0);
                        commit(mutationTypes.SET_PAGINATION_RESPONSE, null);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, repo.searchGlobal(payload.query, payload.paging, payload.version, payload.sorting, payload.name)];
                    case 2:
                        r = _b.sent();
                        if (searchFormsQuery === payload.query) {
                            commit(mutationTypes.SET_FORMS, r.items);
                            commit(mutationTypes.SET_PAGINATION_RESPONSE, EntityBuilder.buildOne(Pagination, r.pagination));
                            commit(mutationTypes.SET_FILTERED_FORM_COUNT, r.pagination.total);
                            if (payload.query === '') {
                                commit(mutationTypes.SET_TOTAL_FORM_COUNT, r.pagination.total);
                            }
                            commit(mutationTypes.SET_LOADING_FORMS, false);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        if (e_1.response && e_1.response.status === 414) {
                            commit(mutationTypes.SET_ERROR, FormRequestError.TOO_MANY_RESULTS);
                        }
                        commit(mutationTypes.SET_LOADING_FORMS, false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    getFormsForJob: function (_a, jobId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit(mutationTypes.SET_LOADING_FORMS, true);
                        _b = commit;
                        _c = [mutationTypes.SET_FORMS];
                        return [4 /*yield*/, container.resolve(FormRepository).getAllForJob(jobId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        commit(mutationTypes.SET_LOADING_FORMS, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    createForm: function (_a, form) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(mutationTypes.SET_LOADING_FORMS, true);
                        return [4 /*yield*/, container.resolve(FormRepository).createForm(form)];
                    case 1:
                        _b.sent();
                        commit(mutationTypes.SET_LOADING_FORMS, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    setApplicationForm: function (_a, form) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var oldApplicationForm;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit(mutationTypes.SET_LOADING_FORMS, true);
                        oldApplicationForm = state.forms.find(function (form) { return form.type === FormTypes.APPLICATION; });
                        if (!oldApplicationForm) return [3 /*break*/, 2];
                        oldApplicationForm.type = null;
                        return [4 /*yield*/, container.resolve(FormRepository).updateForm(oldApplicationForm)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        form.type = FormTypes.APPLICATION;
                        return [4 /*yield*/, container.resolve(FormRepository).updateForm(form)];
                    case 3:
                        _b.sent();
                        commit(mutationTypes.SET_LOADING_FORMS, false);
                        return [2 /*return*/];
                }
            });
        });
    },
};
